import { ITranslations } from 'types/common';
import { CountryFormTransFields } from './types';
import en from 'translations/en/countryForm.json';
import pl from 'translations/pl/countryForm.json';
import sl from 'translations/sl/countryForm.json';

export const countryFormTranslations: ITranslations<CountryFormTransFields> = {
  name: 'countryForm',
  en,
  pl,
  sl,
};
